/**
 * Safe selector wrapper that returns defaultValue when value is null or undefined.
 * Uses explicit check to satisfy SonarQube (avoids || vs ?? issue).
 */
export function safeGet<T>(value: T | null | undefined, defaultValue: T): T {
    if (value === null || value === undefined) {
      return defaultValue;
    }
    return value;
  }